import { get } from 'lodash'
import { useQuery } from 'react-query'
import { AxiosError } from 'axios'

import { fetchAPI } from '@/lib/api'

import { Location } from '../types'
import { Meta } from '@/features/filters/types'

import { LOCATIONS, API_PATH } from '../constants'

type Response = {
  data: Location[]
  meta: Meta
}

const getLocations = async (params: Meta): Promise<Response> => {
  const response = await fetchAPI({
    path: API_PATH,
    params,
  })

  const data = get(response, 'data.locations', [])
  const meta = get(response, 'data.meta', {})

  return { data, meta }
}

export const useLocations = ({
  params = {},
  initialData,
}: {
  params?: Meta
  initialData?: Response
}) => {
  return useQuery<Response, AxiosError>({
    queryKey: [LOCATIONS, params],
    queryFn: () => getLocations(params),
    keepPreviousData: true,
    initialData,
  })
}
